import { Button, Dialog, DialogActions, DialogContent, Typography, useMediaQuery, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import downloadjs from 'downloadjs';
import html2canvas from 'html2canvas';
import * as React from 'react';
import PrintProvider, { Print } from 'react-easy-print';
import { ReporteDeudaType } from '../../hooks/getDeuda';
import { AlumnoType } from '../../types/types';
import { monthToString } from '../../utils/utils';
import { ClosableTitle } from '../DialogTitle';
import { TablaPagos } from './tablaPAgos';


interface ReciboProps {
  onClose: () => void;
  pagos: ReporteDeudaType | null;
  alumno: AlumnoType;
}

export function Recibo(props:ReciboProps) {
  const { alumno, onClose, pagos } = props;
  const fechaActual = dayjs().format('DD-MM-YYYY');

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const handleDownload = async () => {
    const reciboHTML = document.getElementById('recibo-component');
    if (!reciboHTML) return null;
    const canvas = await html2canvas(reciboHTML);
    const dataURL = canvas.toDataURL('image/png');
    const fileName = `recibo-${alumno.name}-${alumno.apellido}-${fechaActual}.png`;
    downloadjs(dataURL, fileName, 'image/png');
  };

  const monto = pagos?.monto ?? 0;
  const totalPagado = pagos?.pagos.reduce((ac, p) => Number(ac) + Number(p.importe), 0) ?? 0;
  const deuda = monto - totalPagado;

  return (
    <div>
      <Dialog open={!!pagos} fullScreen={isMobile} maxWidth={false}>
        <ClosableTitle id="recibo-dialog" onClose={onClose} transparent={false}>Descargar recibo</ClosableTitle>
        <DialogContent>
          {pagos && (
            <PrintProvider>
              <Print single name="printPartList">
                <div id="recibo-component" style={{ position: 'relative', padding: 16 }}>
                  <img src={process.env.PUBLIC_URL + '/logo.png'} style={{ width: 120, position: 'absolute', top: 10, right: 10 }} />
                  <Typography textAlign="center" fontWeight="bold" fontSize={20}>Recibo de pago</Typography>
                  <Typography>Generado el<strong>{` ${fechaActual}`}</strong></Typography>
                  <Typography>Nombre del alumno:<strong>{` ${alumno.name} ${alumno.apellido}`}</strong></Typography>
                  <Typography>Periodo:<strong>{` ${monthToString(Number(pagos.month))} de ${pagos.year}`}</strong></Typography>
                  <Typography>Tipo de pago:<strong>{` ${pagos.esMatricula ? 'MATRICULA' : pagos.esSeguro ? 'SEGURO' : 'CUOTA'}`}</strong></Typography>
                  {pagos.descuento === 0 && <Typography>{pagos.esSeguro ? 'Valor del seguro:' : 'Valor de cuota:'}<strong>
                    {` $${pagos.montoOriginal.toFixed(2)}`}</strong></Typography>}
                  {pagos.descuento > 0 &&
                  <div style={{ textAlign: 'right', margin: 20, width: 150  }}>
                    <Typography style={{ whiteSpace: 'nowrap', fontSize: 16 }}>
                      {`${pagos.esSeguro ? 'Seguro' : 'Cuota'}: $${pagos.montoOriginal.toFixed(2)}`}
                    </Typography>
                    <Typography style={{ whiteSpace: 'nowrap', fontSize: 16 }}>
                      {`${pagos.descuento}% descuento`}
                    </Typography>
                    <Typography style={{ whiteSpace: 'nowrap', fontSize: 20, fontWeight: 'bold' }}>
                      {`Final: $${pagos.monto.toFixed(2)}`}
                    </Typography>
                  </div>
                  }
                  <Typography>Total abonado:<strong>{` $${totalPagado.toFixed(2)}`}</strong></Typography>
                  {totalPagado >= pagos.monto && <Typography
                    style={{ fontWeight: 'bold', fontSize: 20, color: theme.palette.success.main }}
                  >Saldado</Typography>}
                  {deuda > 0 && <Typography>Restante del periodo:<strong>{` $${deuda.toFixed(2)}`}</strong></Typography>}
                  <Typography textAlign="center">Detalle de pagos</Typography>
                  <div style={{ width: 600 }}><TablaPagos pagos={pagos.pagos} /></div>
                </div>
              </Print>
            </PrintProvider>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleDownload}
          >
          Descargar
          </Button>
          <Button
            variant="contained"
            onClick={() => window.print()}
          >
          Imprimir
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );

}